// Data seam for the Catálogo area (estudios / servicios / precios). Prices are
// pesos (priceMxn) on the wire. The page mocks THIS module in tests.

import { apiClient } from '../../api/client.js'

export interface CatalogItem {
  id: string
  name: string
  category: string | null
  priceMxn: number
  description: string | null
  active: boolean
}

export interface NewCatalogItem {
  name: string
  category?: string
  priceMxn: number
  description?: string
}

export interface CatalogItemPatch {
  name?: string
  category?: string | null
  priceMxn?: number
  description?: string | null
  active?: boolean
}

/** GET /catalog — the tenant's estudios/servicios. `priceMxn` is pesos on the wire (API stores cents). */
export async function getCatalog(): Promise<CatalogItem[]> {
  const res = await apiClient.get<{ data: { items: CatalogItem[] } }>('/catalog')
  return res.data.data.items
}

export async function createCatalogItem(input: NewCatalogItem): Promise<CatalogItem> {
  const res = await apiClient.post<{ data: CatalogItem }>('/catalog', input)
  return res.data.data
}

export async function updateCatalogItem(id: string, patch: CatalogItemPatch): Promise<CatalogItem> {
  const res = await apiClient.patch<{ data: CatalogItem }>(`/catalog/${id}`, patch)
  return res.data.data
}
